/*
 * @Author: your name
 * @Date: 2021-06-23 14:32:54
 * @LastEditTime: 2021-06-25 17:25:05
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \JN010665\src\router\module\order.js
 */
export default [
  {
    path: "/order/list/:type?",
    name: "MyOrder",
    meta: {
      title: "我的订单",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/MyOrder")
  },
  {
    path: "/order/logistics/:id",
    name: "Logistics",
    meta: {
      title: "物流信息",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/Logistics")
  },
  {
    path: "/order/cart",
    name: "cart",
    meta: {
      title: "换货",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/cart")
  },
  {
    path: "/order/detail/:id",
    name: "OrderDetails",
    meta: {
      title: "订单详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/OrderDetails")
  },
  {
    path: "/order/payStatus",
    name: "cart",
    meta: {
      title: "支付结果",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/order/payStatus")
  },
  {
    path: "/order/submit/:id",
    name: "OrderSubmission",
    meta: {
      title: "提交订单",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/OrderSubmission")
  },
  {
    path: "/order/status/:id/:status",
    name: "PaymentStatus",
    meta: {
      title: "支付状态",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/PaymentStatus")
  },
  {
    path: "/order/refund/:id",
    name: "GoodsReturn",
    meta: {
      title: "申请退货",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/GoodsReturn.vue")
  },
  {
    path: "/order/refund_list",
    name: "ReturnList",
    meta: {
      title: "退货列表",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/ReturnList.vue")
  },
  {
    path: "/order/OrderLog",
    name: "OrderLog",
    meta: {
      title: "门店订单列表",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/OrderLog.vue")
  }
];
